import FormHeader from '../components/FormHeader';

function SkeletonDestinationForm() {
  return (
    <>
      <FormHeader
        destinationType="email"
        subtitle="Send data to a destination"
        segmentName="Example Audience"
        segmentCollection="Example Collection"
      />
    </>
  );
}

SkeletonDestinationForm.propTypes = {
  segmentType: PropTypes.string,
};

export default SkeletonDestinationForm;
